import { LiveEventBlueprintEvolutionData } from '../../../../features/live-events/types/TrackingEvents'
import { EventEditFormBlueprintEvolutionData } from '../types/EventEditForm'

/**
 * The edit form's blueprint section for a loaded event. The backend leaves out an event's blueprint
 * data, and the `types` / `descriptions` of a blueprint version, when they have no value, while the
 * form's inputs need a blueprint id, a type list and a description per language to bind to.
 */
export const blueprintEvolutionFormValues = (data: LiveEventBlueprintEvolutionData | undefined): EventEditFormBlueprintEvolutionData => ({
  blueprintId: data?.blueprintId ?? '',
  types: data?.types ?? [],
  descriptions: data?.descriptions ?? { en: '', ja: '', zh: '' },
})
